module.exports = __webpack_public_path__ + "hamburger-menu-close.25ae99c5606e7a4f8a044533cd34b4bf.svg";